import { useUserContext } from "@repo/baseCloud";
import { RepFieldAudit } from "@repo/models";
import { EditableGridPage, Loading } from "@repo/ui";

import { useRepFieldAuditQueries } from "../../api/repFieldAuditApi";
import { useSettingsApi } from "../../api/settingsApi";
import { RepFieldAuditProvider, useLocationContext, useRepFieldAuditContext } from "../../contexts/editableItemContext";
import FieldAuditEditor from "./editor";
import FieldAuditGridBasic from "./grid";
import style from "./style.module.scss";

function FieldAudits() {
	return (
		<RepFieldAuditProvider>
			<FieldAuditsInternal />
		</RepFieldAuditProvider>
	);
}

function FieldAuditsInternal() {
	const { locationId, locationLoaded } = useLocationContext();
	const { item, overwriteItem, pendingChanges } = useRepFieldAuditContext();
	const { user } = useUserContext();

	const { useRepFieldAuditQuery } = useRepFieldAuditQueries();
	const { data, loaded } = useRepFieldAuditQuery();
	const { useSettingsQuery } = useSettingsApi();
	const { data: settings } = useSettingsQuery();

	// EditableGridPage only calls these, so they aren't memoized
	const handleOpen = (newItem: RepFieldAudit) => {
		overwriteItem({ ...newItem, isLocationPortal: true });
	};

	const newItem = () => {
		const auditDate = new Date();
		overwriteItem({
			representativeFieldAuditId: 0,
			locationId,
			auditDate,
			operationStart: settings?.defaultStartTime ?? "9:00",
			operationEnd: settings?.defaultEndTime ?? "17:00",
			isLocationPortal: true,
		} as RepFieldAudit);
	};

	return (
		<Loading loading={!loaded || !locationLoaded}>
			<EditableGridPage<RepFieldAudit>
				id="RepFieldAuditsContainer"
				items={data}
				keyProperty="representativeFieldAuditId"
				openItem={handleOpen}
				newItem={newItem}
				pendingChanges={pendingChanges}
				Editor={FieldAuditEditor}
				Grid={FieldAuditGridBasic}
				itemsLoaded={loaded}
				entityId={item?.representativeFieldAuditId ?? 0}
				updateRoute={updateRoute}
				readOnly={!user.userIsAdmin}
				fullReadOnly={false}
				gridContainerClassName={style.gridPageContainer}
			/>
		</Loading>
	);
}

/** The portal keeps the selected audit in context, not the URL */
function updateRoute() {}

export default FieldAudits;
